// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6e47dbf0]::-webkit-scrollbar {\n  height: 0;\n  width: 0;\n  color: transparent;\n}\n.custom-container[data-v-6e47dbf0] {\n  width: 100%;\n  height: 100%;\n  overflow-y: scroll;\n}\n.title[data-v-6e47dbf0] {\n  font-size: 20px;\n  text-align: center;\n  color: #333333;\n  font-weight: bold;\n  padding: 10px 0;\n}\n.line-pie-container[data-v-6e47dbf0] {\n  width: 100%;\n  height: 250px;\n}\n", ""]);
// Exports
module.exports = exports;
